import React from "react";
import SmallRocketPurple from "static/images/SmallRocketPurple.svg";
import SmallPaperPlane from "static/images/SmallPaperPlane.svg";
import { capitalize } from "utils/capitalize";
import { Price } from "./Price";
import { AmountSuperScript } from "./design/AmountSuperScript";
import { BILLING_CYCLE } from "dictionaries";
import classNames from "classnames";

export const CurrentSubscriptionCard = ({
  planName,
  amount,
  frequency,
  isCurrentYearIncorporated,
}: {
  planName: string;
  amount: number;
  frequency: "YEARLY" | "MONTHLY" | "QUARTERLY";
  isCurrentYearIncorporated?: boolean;
}) => (
  <div className="t-border t-border-solid t-p-3 t-rounded t-border-purple-10 t-bg-purple-0 t-flex t-gap-3 t-items-center t-flex-1">
    <img src={SmallRocketPurple} alt="SmallRocketPurple" />
    <div>
      <div className="t-text-subtext-sm t-text-text-100 t-min-w-fit">
        {planName}
      </div>
      <div className="t-text-text-30 t-text-body-sm t-mt-0.5">
        <span
          className={classNames("t-text-subtext-sm t-text-neutral-80", {
            "t-line-through": isCurrentYearIncorporated,
          })}
        >
          <AmountSuperScript amount={amount} />
          <span>/{BILLING_CYCLE[frequency]}</span>
        </span>
        {isCurrentYearIncorporated && (
          <div className="t-text-subtext">Free</div>
        )}
      </div>
    </div>
  </div>
);

export const FreePlanCard = () => (
  <div className="t-border t-border-solid t-p-3 t-rounded t-border-neutral-0 t-bg-surface-lighter-grey t-flex t-gap-3 t-items-center t-flex-1">
    <img src={SmallPaperPlane} alt="SmallPaperPlane" />
    <div>
      <div className="t-text-subtext-sm t-text-text-100">Free Plan</div>
      <span className="t-text-subtext-sm t-text-neutral-80">
        <AmountSuperScript amount={0} />
        <span>/month</span>
      </span>
    </div>
  </div>
);
